<div class="screen-container">
    <app-card [title]="'noIdinBank.title' | translate">
        <div left-content>
            <form [formGroup]="noIdinBankForm">
                <div class="content-container">

                    <div class="input-container">
                        <app-input
                            [label]="'noIdinBank.firstName'"
                            [control]="firstName"
                            [error]="getErrors('firstName')"
                        ></app-input>
                    </div>

                    <div class="input-container">
                        <app-input
                            [label]="'noIdinBank.lastNamePrefix'"
                            [control]="lastNamePrefix"
                            [error]="getErrors('lastNamePrefix')"
                        ></app-input>
                    </div>

                    <div class="input-container">
                        <app-input
                            [label]="'noIdinBank.lastName'"
                            [control]="lastName"
                            [error]="getErrors('lastName')"
                        ></app-input>
                    </div>

                    <div class="input-container">
                        <app-dropdown
                            [label]="'noIdinBank.genderSelect'"
                            [control]="gender"
                            [options]="genderOptions"
                            [optionsTranslationKey]="'noIdinBank.genderOptions'"
                            [hideCaret]="true"
                            [error]="getErrors('gender')"
                        ></app-dropdown>
                    </div>
                    
                    <div class="input-container">
                        <app-datepicker
                            [label]="'noIdinBank.dateOfBirth'"
                            [control]="dateOfBirth"
                            [picker]="'dobPicker'"
                            [max]="minAge"
                            [icon]="'calender'"
                            [startDate]="startDate" 
                            [error]="getErrors('dateOfBirth')"
                        ></app-datepicker>
                    </div>

                    <div class="input-container">
                        <app-input
                            [label]="'noIdinBank.bsn'"
                            [control]="bsn"
                            [icon]="'person'"
                            [error]="getErrors('bsn')"
                        ></app-input>
                    </div>

                    <div class="button-container">
                        <app-deeplink-button
                            (buttonClicked)="handleButtonClick()"
                            mat-flat-button
                            color="primary"
                            [icon]="'none'"
                            [text]="'noIdinBank.buttonText' | translate"
                            [fullWidth]="true"
                            [loading]="confirmationLoading"
                        ></app-deeplink-button>
                    </div>

                    <div class="note"> </div>
                    <div class="mat-error error" *ngIf="error">
                        {{ error }}
                    </div>
                </div>
            </form>
        </div>
        <div right-content>
            <app-contact></app-contact>
        </div>
    </app-card>
</div>